// src/firebaseClient.js
import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCAymkDtQDAyjFWdkghYe-A0pcsds5OvBI",
  authDomain: "fir-ai-dashboard.firebaseapp.com",
  projectId: "fir-ai-dashboard",
  storageBucket: "fir-ai-dashboard.firebasestorage.app",
  messagingSenderId: "509388848986",
  appId: "1:509388848986:web:5621bdaba0373e8f79fd63"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Wir nutzen localPersistence, sodass der User auch nach einem Reload angemeldet bleibt.
setPersistence(auth, browserLocalPersistence);

export { auth };
